/**
 * 내 계정 API 파사드(specs/053) — 표시 이름 변경. 인증 주체 본인만 대상(식별자 미전달).
 * 400(빈 값·길이·문자 규칙)은 변경 창이 인라인으로 보여 주므로 무음.
 */
import { http, withErrors } from './http';

/** 계정 표시 정보(백엔드 AccountProfileResponse). */
export interface AccountProfile {
  displayName: string;
  email: string | null;
}

/** 표시 이름 변경 요청(백엔드 DisplayNameChangeRequest). */
export interface DisplayNameChangeRequest {
  displayName: string;
}

export async function changeDisplayName(displayName: string): Promise<AccountProfile> {
  const { data } = await http.put<AccountProfile>(
    '/fo/account/display-name',
    { displayName } satisfies DisplayNameChangeRequest,
    withErrors({ silentStatuses: [400] }),
  );
  return data;
}
